
import React, { useState } from 'react';
import { RestaurantSelectorProps } from './types';
import { RestaurantButtonSelector } from './RestaurantButtonSelector';
import { RestaurantCardSelector } from './RestaurantCardSelector';
import { RestaurantDropdownSelector } from './RestaurantDropdownSelector';

const RestaurantSelector: React.FC<RestaurantSelectorProps> = ({
  restaurants,
  selectedRestaurants,
  onRestaurantChange,
  displayType = 'dropdown',
  showFullCard = false,
  label = 'Restaurants:',
  className = '',
  showMetrics = false,
  cardClassName = '',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!restaurants || restaurants.length === 0) {
    return null;
  }

  const handleMultiSelection = (restaurantId: string, closeAfterSelection = false) => {
    if (restaurantId === 'all') {
      onRestaurantChange(['all']);
      return;
    }

    let newSelection = selectedRestaurants.includes('all')
      ? []
      : [...selectedRestaurants];

    if (newSelection.includes(restaurantId)) {
      if (newSelection.length === 1) {
        newSelection = ['all'];
      } else {
        newSelection = newSelection.filter(id => id !== restaurantId);
      }
    } else {
      newSelection.push(restaurantId);
    }

    if (newSelection.length === 0) {
      newSelection = ['all'];
    }

    onRestaurantChange(newSelection);
  };

  const getDisplayValue = () => {
    if (selectedRestaurants.includes('all')) {
      return 'All Restaurants';
    }
    
    if (selectedRestaurants.length === 1) {
      const restaurant = restaurants.find(r => r.id === selectedRestaurants[0]);
      return restaurant ? restaurant.name : 'Select Restaurant';
    }
    
    return `${selectedRestaurants.length} Restaurants Selected`;
  };

  if (displayType === 'buttons') {
    return (
      <RestaurantButtonSelector
        restaurants={restaurants}
        selectedRestaurants={selectedRestaurants}
        onRestaurantChange={onRestaurantChange}
        onMultiSelection={handleMultiSelection}
        className={className}
      />
    );
  }

  if (displayType === 'cards') {
    return (
      <RestaurantCardSelector 
        restaurants={restaurants}
        selectedRestaurants={selectedRestaurants}
        onRestaurantChange={onRestaurantChange}
        onMultiSelection={handleMultiSelection}
        showMetrics={showMetrics}
        cardClassName={cardClassName}
        className={className}
      />
    );
  }

  return (
    <RestaurantDropdownSelector
      restaurants={restaurants}
      selectedRestaurants={selectedRestaurants}
      onRestaurantChange={onRestaurantChange}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      label={label}
      showFullCard={showFullCard}
      onMultiSelection={handleMultiSelection}
      getDisplayValue={getDisplayValue}
      className={className}
    />
  );
};

export default RestaurantSelector;
